/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpgradeAssistantIdentityRequestBody,
  UpgradeAssistantIdentityRequestBody$Outbound,
  UpgradeAssistantIdentityRequestBody$outboundSchema,
} from "../components/upgradeassistantidentityrequestbody.js";

export type UpgradeAssistantIdentitySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpgradeAssistantIdentityRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  upgradeAssistantIdentityRequestBody: UpgradeAssistantIdentityRequestBody;
};

/** @internal */
export type UpgradeAssistantIdentitySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpgradeAssistantIdentitySecurity$outboundSchema: z.ZodMiniType<
  UpgradeAssistantIdentitySecurity$Outbound,
  UpgradeAssistantIdentitySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upgradeAssistantIdentitySecurityToJSON(
  upgradeAssistantIdentitySecurity: UpgradeAssistantIdentitySecurity,
): string {
  return JSON.stringify(
    UpgradeAssistantIdentitySecurity$outboundSchema.parse(
      upgradeAssistantIdentitySecurity,
    ),
  );
}

/** @internal */
export type UpgradeAssistantIdentityRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpgradeAssistantIdentityRequestBody:
    UpgradeAssistantIdentityRequestBody$Outbound;
};

/** @internal */
export const UpgradeAssistantIdentityRequest$outboundSchema: z.ZodMiniType<
  UpgradeAssistantIdentityRequest$Outbound,
  UpgradeAssistantIdentityRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    upgradeAssistantIdentityRequestBody:
      UpgradeAssistantIdentityRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      upgradeAssistantIdentityRequestBody:
        "UpgradeAssistantIdentityRequestBody",
    });
  }),
);

export function upgradeAssistantIdentityRequestToJSON(
  upgradeAssistantIdentityRequest: UpgradeAssistantIdentityRequest,
): string {
  return JSON.stringify(
    UpgradeAssistantIdentityRequest$outboundSchema.parse(
      upgradeAssistantIdentityRequest,
    ),
  );
}
